import React from 'react';
import type ProductsJswConfigurationType from '@atlassian/jira-spa-apps-products-jsw-configuration/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProductsJswConfiguration = lazyForPaint<typeof ProductsJswConfigurationType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsw-configuration", jiraSpaEntry: "async-products-jsw-configuration" */ '@atlassian/jira-spa-apps-products-jsw-configuration'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProductsJswConfiguration}
		pageId="products-jsw-configuration"
		shouldShowSpinner={false}
	/>
);
